const zh = {
  common: {
    lang: '語言',
    back: '返回',
    next: '下一步',
    submit: '提交',
    loading: '載入中...',
  },
  homeIndex: {
    featureSearchAvailability: '搜尋可用性',
    featureSchedule: '安排',
    featureConfirmationReceipt: '確認/收到',
    featureReschedule: '重新安排',
    featureCancel: '取消',
  },
  scheduleAppointment: {
    title: '考試預約',
    examSelection: '考試選擇',
    testingWindow: '可預約日期',
    scheduleTestCenter: '預約到考試中心',
    scheduleRemoteAssessment: '預約為線上考試',
    selectSponsorLabel: '選擇一個考試主辦方',
    selectSponsorPlaceHolder: '請選擇一個考試主辦方',
    selectProgramLabel: '選擇 一個計劃',
    selectProgramPlaceHolder: '請選擇一個計劃',
    selectRightSponsorLabel: '考試主辦方：',
    selectRightProgramLabel: '計劃名稱：',
    selectRightQualificationLabel: '資格資訊：',
    selectRightTestLabel: '考試名稱：',
    agreementFirst:
      '我確認我在註冊居所管轄區已達法定年齡，或我是數據主體和／或考生的家長或監護人，並獲授權就個人數據的收集和處理，做出下列所需的同意與否的選擇。',
    agreementSecond: '我同意我的個人數據被收集與處理，如本個人數據隱私披露與同意書所述。',
    agreementThird:
      '我同意將我的個人數據轉移到我參加考試以外的國家/地區，如本個人數據隱私披露和同意表第 4 節所述，詳細資訊可查閱',
    agreementThirdHref: '通過閱讀隱私政策。',
    agreementTips: '若您不同意我們收集、傳輸、處理、使用和儲存您的個人數據，請與您的考試主辦方聯繫。',
  },
  privacyConfirm: {
    row_1: '個人數據隱私披露與同意',
    row_2: `Prometric（此後稱為 "Prometric" 或 "我們" 或
    "我們的"）是您的考試主辦方的數據處理者，考試主辦方則是數據控制者。我們的主要辦公室位於 1501 South Clinton
    Street，巴爾的摩，馬里蘭州 21224，美國。`,
    row_3: '1. 目的',
    row_4:
      '我們根據您的同意處理您的個人數據，用於為您註冊並安排您參加考試、舉辦考試、防止欺詐，以及處理成績的目的。在當地法律允許的情況下，我們也將根據我們的合法權益處理您的個人數據，以改善我們提供給您的考試主辦方的防止欺詐服務與其他考試服務。關於我們的防止欺詐服務，這些流程使用專有演算法來分析由錄像視頻所記取的元數據。為最大限度地減少所處理的個人數據，一旦錄像記取了元數據，您的個人數據將被匿名化，以避免它與您的個人數據相關聯。',
    row_5: `若沒有通知您或未經您的許可，Prometric
      絕不會將您的個人數據用於任何其他目的。您的個人數據（包括您的考試成績）都將提供給您的考試主辦方，用於提供分數、認證或其他與考試相關服務的目的。完整的
      Prometric 隱私權政策（包括如何提交數據主體訪問請求的指示）可在以下網址找到：`,
    row_6: '2. 使用錄像與錄音以監控考試的進行',
    row_7: `在以電腦操作的考試中心，Prometric
    將在所有考試交付地點採用數字錄像（DVR）或閉路電視（CCTV）。在適用法律允許的情況下，這包括在接待處／儲物櫃、監考／安全登記過程中，以及考試實驗室區進行的錄音。為了保護高利害關係專項考試內容的安全性、考試交付體驗的完整性，阻止欺詐和欺騙並防止盜竊和偷盜，以及保護職員與公司財產，這麼做是必要的。錄製的內容將嚴格限於授權人員接觸，並按適用當地法律保留三十（30）天或更短時間。在一些情況下，如果需要用作合法證據，錄製的內容將保留更長時間。`,
    row_8: `在我們的遠程監考平台（ProProctor）上，Prometric
    收集由登記流程開始並於考試全程錄製的錄像視頻，包括錄音在內。有時，這將包括您的辦公桌和工作區。我們將對您和您的工作區、辦公桌以及您的工作區內的聲音進行實時監控，並在考試進行期間記取與錄下，以保護高利害關係專項考試內容的安全性、考試交付體驗的完整性，以及阻止欺詐和欺騙。ProProctor
    的錄音與錄像將嚴格限於授權人員接觸，並保留三十（30）天，或適用法律允許的期限（即合法證據）。`,
    row_9: `為確保您的考試的完整性，我們的遠程監考平台（ProProctor）上的防止欺詐服務有可能會記取與您的特定考試相關的元數據，包括：IP地址、設備ID/電子序列號、地理位置、VPN
    狀態、虛擬機的使用，或遠程桌面協議軟體。`,
    row_10: '3. 分享您的個人數據',
    row_11: `我們可能會僱用其他公司和個人代表我們履行職能。可查閱個人數據的我方員工、代理和承包商需按照 Prometric
    隱私權政策保護數據，對數據保密並維護數據主體的權利，而且我們要求第三方確保像 Prometric
    對其員工要求的那樣保護隱私權，並遵守包括適用的數據保護法在內的相關規定。我們不會將個人數據傳送給非經相應合約關係擔任
    Prometric 代理或代表的第三方。`,
    row_12: `美國國內考生的個人數據將可以從美國訪問，或者傳輸到美國進行處理和儲存，國際考生的個人數據將按考生居住的國家所屬區域進行處理，但公司位於世界其他地方的附屬機構和數據處理者將可因為本聲明首段所概述的目的所需而訪問數據。"國際考生"
    指的是在美國境外永久居住且不持有美國護照的考生或員工。無論個人位置（最初收集或最終處理或存儲該個人的數據的地方）在何處，Prometric
    將始終保護個人數據的隱私和安全。您申請和／或聯繫考試主辦方以參加考試，通過 Prometric
    報名和安排考試時間，並在下方點擊"我同意"予以同意，即表示授權我們向您（即數據主體和／或考生）收集個人數據並加以處理。`,
    row_13: '4. 數據傳輸',
    row_14: '考生個人數據將可因為第一節所概述的目的所需而從美國訪問，或者傳輸到美國進行處理和儲存。',
    row_15: `Prometric 遵循適用的當地數據保護法的要求來將數據傳輸給第三方國家。Prometric
    以由歐盟委員會批准的標準合約條款為依據，在我們位於歐洲的單位與我們位於世界其他地點的處理個人數據的單位之間，進行數據傳輸。我們也和我們的客戶與服務提供者簽訂數據處理協議。`,
    row_16: '5. 您的權利',
    row_17: `按適用的當地法律，您可以要求訪問、更正、清除、轉移、限制，
    或反對處理您的個人數據，或向您當地的監管機構查詢、提出請求、投訴，或在正常營業時間裡聯絡您的考試主辦方，以撤回與之相關的同意。您也可到`,
    row_18:
      '您若前往註冊並安排考試時間，即准許我們收集並處理您的個人數據，如本個人數據隱私披露與同意書所述。您確認並同意我們在考試期間對您進行實時監控與錄製。因此，請您將您的個人空間裡的任何個人的照片或您或其他人的其他個人數據清除，以避免錄像無意間記取到。',
    modalTips: '請等待大約3到5分鐘，直到您的資格數據變得可用。如果您找不到您的資格資訊，請等待並重試或聯繫客戶服務。',
    modalTips2: '缺少參數',
    modalTips3: '資格碼無效，請聯繫客服',
  },
  profile: {
    title: '完善資訊',
    profileTips:
      '用於安排預約的姓名資訊必須與您的身份證件上顯示的姓名完全一致。該身份證件必須是政府頒發的有效身份證。考試主辦方可能有其他身份證件政策。有關詳細資訊，請諮詢您的考試主辦方。',
    requiredField: '表示必填欄位',
    firstName: '名',
    lastName: '姓',
    idNumber: '證件號',
    idNumberPlaceholder2: '必須與您的騰訊雲身份驗證資訊一致',
    idType: '證件類型',
    email: '郵箱',
    confirmEmail: '確認郵箱',
    firstNameTips: '請輸入您的名',
    lastNameTips: '請輸入您的姓',
    idNumberTips: '請輸入您的證件號',
    idTypeTips: '請選擇證件類型',
    emailTips: '請輸入您的郵箱',
    emailTips2: '請輸入您的郵箱正確',
    emailTips3: '兩次輸入的郵箱不一致',
    firstNamePlaceholder: '請填寫您的名字',
    lastNamePlaceholder: '請填寫您的姓氏',
    idNumberPlaceholder: '請填寫您的證件號',
    modalTips1: '您的個人資訊無法驗證。請確保您正確輸入您的 IDNumber、LastName 和 FirstName 或聯繫您的測試贊助商。',
    modalTips2: '資格碼無效，請聯繫客服',
    modalTips3: '系統訪問超時，請稍候重試。',
  },
}
export default zh
